import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';

$.addInit(function(context){
	var base = '.b-subMenu';
	$(base, context).each(function(){
		var component = $(this);

		var elements = {
			menu: '.i-subMenu-menu',
		};

		var refs = {
			menuWrap: component,
			rootMenu: component.children(base + '-menu'),
			backBtn: component.find(base + '-linkBack'),
			link: component.find(base + '-linkDropdown'),
			items: component.closest('.b-menu').find('.b-menu-item').not('.b-menu-itemMain'),
		}

		var currentMenu = refs.rootMenu;
		var currentLevel = 0;

		function getPrevMenu() {
			return currentMenu.parent().closest(elements.menu);
		}

		function setLevel(level) {
			refs.rootMenu.css('left', -100 * level + '%');
			currentLevel = level;
		}

		function setMenu(menu) {
			var level = menu.parents(elements.menu).length;

			menu.show();
			refs.menuWrap.css('height', menu.height());

			refs.items.prop('hidden', level > 0);

			if (refs.rootMenu.css('transitionDuration') !== '0s') {
				refs.rootMenu.one('transitionend', function(){
					menu.find(elements.menu).hide();
				});
			} else {
				menu.find(elements.menu).hide();
			}

			if (level > 0) {
				menu.css({
					top: refs.menuWrap.prop('scrollTop') + 'px',
				});

				menu.addClass('m-sub');
			}

			setLevel(level);
			currentMenu = menu;
		}

		var head = component.closest('.b-head');

		function setHeight() {
			var maxHeight = 0;

			$(elements.menu).each(function(){
				$(this).height('auto');
				if ( $(this).height() > maxHeight ) {
					maxHeight = $(this).height();
				}
			});

			if (maxHeight + head.height() + 60 + 8 < $(window).height() ) {
				$(elements.menu).height(maxHeight);
			} else {
				$(elements.menu).css({
					height: 'calc(100vh - 250px)'
				});
			}
		}

		function unSetHeight() {
			$(elements.menu).height('auto');
		}

		function linkHandler(e) {
			e.preventDefault();
			var findMenu = $(this).siblings(elements.menu);
			setMenu(findMenu);
		}

		function backHandler(e) {
			e.preventDefault();
			setMenu(getPrevMenu());
		}

		function attach() {
			refs.link.on('click', linkHandler);
			refs.backBtn.on('click', backHandler);

			setTimeout(function() {
				setMenu(refs.rootMenu);
			}, 0);
		}

		function deattach() {
			refs.link.off('click', linkHandler);
			refs.backBtn.off('click', backHandler);
		}


		breakpoint(null, 'lg')
		.onmatch(function(){
				attach();

				unSetHeight();
				$(window).off('resize', setHeight);
			})
			.onmismatch(function() {
				deattach();

				$(elements.menu).removeAttr('style');
				component.removeAttr('style');

				setHeight();
				$(window).on('resize', setHeight);
			});
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-subMenu.js
// module id = 51
// module chunks = 0